<simpayx-header></simpayx-header>
<ion-header mode="ios">
  <ion-buttons slot="start">
    <ion-back-button defaultHref="{{ backHref }}"></ion-back-button>
  </ion-buttons>
  <ion-title>Addresses</ion-title>
</ion-header>
<ion-content>
  <ion-button fill="outline" expand="block" class="ion-padding" (click)="openAddressModal()">Add Address</ion-button>
  <ion-grid *ngIf="!isLoading; else spinner">
    <ion-list *ngFor="let address of addresses">
      <ion-card class="banner-card">
        <ion-card-header class="ion-padding">
          <!-- Display address tag, if available -->
          <ion-card-title *ngIf="address.tag">{{
            address.tag | uppercase
          }}</ion-card-title>
        </ion-card-header>
        <ion-card-content class="card-background">
          <ion-row>
            <ion-col>
              <!-- Display address details -->
              House / Flat / Block No. : {{ address.line1 }}<br />
              Apartment / Road / Area : {{ address.line2 }}<br />
              City : {{ address.city }}<br />
              State : {{ address.state }}<br />
              Country : {{ address.country }}<br />
              Pin Code : {{ address.zip }}
            </ion-col>
          </ion-row>
          <ion-row class="edit-button bold">
            <ion-col (click)="updateAddress(address)"> Edit </ion-col>
            <ion-col class="vertical-line ion-no-padding">|</ion-col>
            <ion-col (click)="confirmDeletion(address)"> Delete </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </ion-list>
  </ion-grid>
  <ion-grid>
    <ion-row
      class="d-flex ion-align-items-center"
      *ngIf="addresses?.length === 0"
    >
      <ion-col class="spin d-flex ion-justify-content-center">
        <ion-card class="no-address-card">
          <ion-card-content>
            <ion-label class="spx-font-16"> No saved address! </ion-label>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #spinner>
    <ion-grid>
      <ion-spinner class="spin"></ion-spinner>
    </ion-grid>
  </ng-template>
</ion-content>
<ion-footer mode="ios">
  <ion-toolbar style="height: 25px;">
    <ion-title style="font-size: small; align-items: normal;">Powered by SimpayX</ion-title>
  </ion-toolbar>
</ion-footer>